import { Activity, Clock, AlertTriangle, Gauge, Route } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const formatNumber = (num) => {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toLocaleString();
};

const KpiCards = ({ kpis }) => {
  const items = [
    { label: 'Total Requests', value: formatNumber(kpis.total_requests), icon: Activity },
    { label: 'Avg Duration', value: `${Math.round(kpis.avg_duration_ms)}ms`, icon: Clock },
    { label: 'Error Rate', value: `${kpis.error_rate.toFixed(1)}%`, icon: AlertTriangle },
    { label: 'P95 Duration', value: `${kpis.p95_duration_ms}ms`, icon: Gauge },
    { label: 'Unique Routes', value: kpis.unique_routes.toString(), icon: Route }
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
      {items.map((item) => (
        <Card key={item.label}>
          <CardContent className="p-4">
            <div className="flex items-center justify-between pb-2">
              <div className="tracking-tight text-sm font-medium text-muted-foreground">{item.label}</div>
              <item.icon className="h-4 w-4 text-muted-foreground" />
            </div>
            <div className="text-2xl font-bold">{item.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default KpiCards;
